import type { Event_Entry } from '@/types/graphql';
import { getShowButtonText, getShowButtonVariant, getShowPageLink } from '@/utils/show';
import { useTranslations } from 'next-intl';
import type { ButtonVariant } from '../atoms/ButtonLink';
import ButtonLink from '../atoms/ButtonLink';

interface ShowTilePurchaseButtonProps {
    event: Event_Entry;
}

export default function ShowTilePurchaseButton({ event }: ShowTilePurchaseButtonProps) {
    const variant = getShowButtonVariant(event);
    const t = useTranslations('ShowTilePurchaseButton');

    if (event.eventProgramStart && new Date(event.eventProgramStart) <= new Date()) {
        return null;
    }

    if (!event.slug) {
        return null;
    }

    return (
        <div className="event-tile__button p-2 pt-0">
            <ButtonLink
                dummy={true}
                href={getShowPageLink(event)}
                variant={variant as ButtonVariant}
                disabled={event.eventStatus !== 'active'}
                className="flex items-center justify-center gap-x-2"
            >
                {t(getShowButtonText(event))}
            </ButtonLink>
        </div>
    );
}
